import { render, staticRenderFns } from "./option-detail.vue?vue&type=template&id=4e003268&scoped=true"
import script from "./option-detail.vue?vue&type=script&lang=ts"
export * from "./option-detail.vue?vue&type=script&lang=ts"
import style0 from "./option-detail.vue?vue&type=style&index=0&id=4e003268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e003268",
  null
  
)

export default component.exports